import React, { useState } from "react";
import { observer } from "mobx-react";

import TextField from "@mui/material/TextField";

interface PexelsPickerProps {
    pexels_url: string;
    subject: any;
    setPexelsURL: Function;
}

const PexelsPicker = observer(({ pexels_url, subject, setPexelsURL }: PexelsPickerProps) => {
    let [imageURL, setImageURL] = useState("");
    const readImageLink = (ev: React.ChangeEvent<HTMLInputElement>) => {
        var regex = /https:\/\/www.pexels.com\/photo\/.*-(\d+)\//;
        var found = ev.target.value.match(regex);

        if (found) {
            setImageURL(
                `https://images.pexels.com/photos/${found[1]}/pexels-photo-${found[1]}.jpeg?w=640`
            );
        }

        setPexelsURL(ev.target.value);
        //\/.*([0-9]+)\/
        // https://www.pexels.com/photo/art-blur-cappuccino-close-up-302899/
        //
        // https://images.pexels.com/photos/302899/pexels-photo-302899.jpeg?w=640
    };

    let image: any = <span></span>;
    if (imageURL) {
        image = (
            <div>
                <img width="50%" src={imageURL} />
            </div>
        );
    }

    return (
        <label>
            <div className="form-label">
                For your image header, Paste a URL from a{" "}
                <a href="https://www.pexels.com">pexels</a> here:
            </div>

            <TextField
                className="form-control"
                onChange={readImageLink}
                value={pexels_url}
            />
            <br />
            {image}
        </label>
    );
});

export default PexelsPicker;
